import React from 'react';

const Instructions = () => (
  <div className="instructions">
    <h3>Ennen sokerointia</h3>
    <ul>
      <li>Älä kuori sokeroitavaa aluetta 24h ennen hoitoa</li>
      <li>Sopiva karvanpituus on vähintään 2mm</li>
      <li>Älä kosteuta sokeroitavaa aluetta samana päivänä</li>
    </ul>

    <h3>Kotihoito-ohjeet sokeroinnin jälkeen</h3>
    <ul>
      <li>Vältä hikoilua 24h</li>
      <li>Vältä uintia 24h</li>
      <li>Kainalokarvojen poiston jälkeen vältä deodorantin käyttöä 24h</li>
      <li>
        Jos sinulta on poistettu karvoja kasvojen alueelta, vältä tukkivia
        meikkiaineita 24h
      </li>
      <li>
        Vältä aurinkoa/solariumia samana päivänä. Suojaa ihosi seuraavana
        päivänä
      </li>
      <li>Älä käytä itseruskettavia aineita 24h aikana</li>
      <li>
        Kuori ihosi kolmen päivän päästä sokeroinnista ja jatkossa enintään
        kerran viikossa
      </li>
      <li>Vältä hankaavia ja tiukkoja vaatteita sokeroinnin jälkeen</li>
      <li>Brasilialaisen sokeroinnin jälkeen huolehdi hyvin hygieniasta 24h</li>
    </ul>
    <h3>Esteet sokeroinnille</h3>
    <ul>
      <li>Ihotulehdukset</li>
      <li>Tuoreet arvet</li>
      <li>Haavat</li>
      <li>Isot mustelmat</li>
      <li>Isot ja arat suonikohjut</li>
      <li>Auringon polttama iho</li>
      <li>Syylät sokeroitavalla alueella</li>
      <li>
        Retin-A -lääkitys, Retinol- hoito tai -lääkitys tai Roacutan- lääkitys
      </li>
      <li>Varsiluomet hoidettavalla alueella</li>
    </ul>
  </div>
);

export default Instructions;
